<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="false">
      <template #header>搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="120px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onTableSearch">
        <div class="re-el-form__flex">
          <el-form-item label="零工ID"
                        prop="userid">
            <el-input v-model="search.userid"
                      placeholder="请输入零工ID"
                      clearable />
          </el-form-item>
          <el-form-item label="客户"
                        prop="customerid">
            <remote-select
              placeholder="请输入客户名称/编号搜索"
              v-model="search.customerid"
              :query-request="getCustomerTable"
              :find-request="getCustomerDetail"
              clearable />
          </el-form-item>
          <el-form-item label="零工手机号"
                        prop="cellphone">
            <el-input v-model="search.cellphone"
                      placeholder="请输入零工手机号"
                      clearable />
          </el-form-item>
          <el-form-item label="客户完单风险"
                        prop="has_customer_risk">
            <el-select v-model="search.has_customer_risk"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option
                v-for="(label, key) in {1: '是', 2: '否'}"
                :key="key"
                :label="label"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单失效风险"
                        prop="has_invalid_risk">
            <el-select v-model="search.has_invalid_risk"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option
                v-for="(label, key) in {1: '是', 2: '否'}"
                :key="key"
                :label="label"
                :value="key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="风险状态"
                        prop="risk_status">
            <el-select v-model="search.risk_status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="(label, value) in riskusersOpts.riskStatusOpts"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认状态"
                        prop="confirm_status">
            <el-select v-model="search.confirm_status"
                       placeholder="请选择"
                       class="width-max"
                       clearable>
              <el-option
                v-for="(label, value) in riskusersOpts.riskConfirmStatusOpts"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省市区"
                        prop="regionids">
            <el-cascader
              v-model="search.regionids"
              class="width-max"
              :options="chinaAreaData"
              :props="{ multiple: true, checkStrictly: true }"
              filterable
              clearable >
            </el-cascader>
          </el-form-item>
          <el-form-item label="负责人"
                        prop="confirmed_adminuserid">
            <remote-select
              class="width-max"
              clearable
              placeholder="请输入管理员"
              keyword-key="name"
              v-model="search.confirmed_adminuserid"
              :query-request="getBasicPlatformUsersIndex"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="触发风险时间"
                        prop="became_risk_at">
            <el-date-picker v-model="search.became_risk_at"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :picker-options="dateTimePickerRangeOptions"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="width-max"
                            :default-time="['00:00:00', '23:59:59']"
                            clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" native-type="submit">搜索</el-button>
          <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel :show-header="false">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="risk-user-stat-card">
            <div class="risk-user-stat-card__label">总零工数</div>
            <div class="risk-user-stat-card__value">{{ stats.total_user_cnt | seperateThousands }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="risk-user-stat-card">
            <div class="risk-user-stat-card__label">单一客户完单风险用户数</div>
            <div class="risk-user-stat-card__value">{{ stats.customer_risk_user_cnt | seperateThousands }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="risk-user-stat-card">
            <div class="risk-user-stat-card__label">工单失效用户数</div>
            <div class="risk-user-stat-card__value">{{ stats.invalid_risk_user_cnt | seperateThousands }}</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="risk-user-stat-card">
            <div class="risk-user-stat-card__label">高风险用户占比</div>
            <div class="risk-user-stat-card__value">{{ stats.high_risk_percent }}%</div>
          </div>
        </el-col>
      </el-row>
    </layout-panel>
    <layout-panel>
      <template #header>列表</template>
      <template #tools>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button style="margin-right: 5px;"
                   type="success"
                   icon="sj-icon-export"
                   @click="onExportSearch"
                   size="small">按搜索结果导出
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <template v-for="attr of fields">
          <!-- @最佳参考:表格数据配置格式化  -->
          <el-table-column v-bind="attr">
            <template #header>
              <span>{{attr.label}}</span>
              <el-tooltip v-if="attr.tooltip"
                          :content="attr.tooltip">
                <i class="el-icon-warning"></i>
              </el-tooltip>
            </template>
            <template v-slot="scope">
              <div :class="attr.class ? attr.class(attr, scope.row) : null"
                   v-html="htmlRow(attr.formatter ? attr.formatter(scope.row) : scope.row[attr.prop])">
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column fixed="right"
                         label="操作"
                         width="140"
                         align="center">
          <template v-slot="scope">
            <el-link type="primary"
                     style="display: inline-block; padding: 0 5px"
                     :underline="false"
                     :href="`/users/riskusers/detail/${scope.row.userid}`"> 跟进
            </el-link>
            <el-link type="primary"
                     style="display: inline-block; padding: 0 5px"
                     :underline="false"
                     :href="`/order/table?userid=${scope.row.userid}`"> 工单列表
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          @size-change="handleSizePageChange"
          @current-change="handleCurrentPageChange"
          :current-page="pagination.current_page"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pagination.per_page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table, { removeEmptyParams } from '@core/mixins/table-v3'
import userRiskMixins from '@views/users/user-risk.mixins'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [table, userRiskMixins, dateTimePicker],
  computed: {
    ...Vuex.mapState({
      riskusersOpts: state => state.users.riskusersOpts,
    }),
  },
  created () {
    this.getChinaAreaData()
    this.$nextTick(() => this.loadStats()) // 使用$nextTick避免搜索参数未生成
  },
  data () {
    return {
      search: {
        userid: null,
        customerid: null,
        cellphone: null,
        has_customer_risk: null,
        has_invalid_risk: null,
        risk_status: null,
        confirm_status: null,
        confirmed_adminuserid: null,
        became_risk_at: [],
        regionids: [],
      },
      searchFieldType: {
        order_percent: Array,
        total_invalid_percent: Array,
        became_risk_at: Array,
      },
      chinaAreaData: [],
      fields: [
        { prop: 'userid', label: '零工ID', width: 80 },
        { prop: 'realname', label: '姓名', width: 80 },
        { prop: 'province_name', label: '省份' },
        { prop: 'city_name', label: '城市' },
        { prop: 'area_name', label: '地区' },
        { prop: 'total_pass_order_count', label: '累计完单数', tooltip: '近期一年数据' },
        {
          prop: 'customer_stats__formatted',
          label: '单一客户完单率',
          width: 180,
          tooltip: '大于等于值80%',
          class: (attr, row) => ({ 'is-risk': this.isRiskClass(attr.prop, row) }),
          formatter: (row) => row.customer_stats.length > 0 ? this.joinCustomer(row.customer_stats) : ''
        },
        {
          prop: 'total_invalid_percent__formatted',
          label: '工单失效率',
          tooltip: '大于等于值70%',
          class: (attr, row) => ({ 'is-risk': this.isRiskClass(attr.prop, row) }),
          formatter: (row) => row.total_invalid_percent ? `${row.total_invalid_percent}%` : ''
        },
        {
          prop: 'risk_status__formatted',
          label: '风险状态',
          width: 90,
          class: (attr, row) => ({ 'is-risk': this.isRiskClass(attr.prop, row) }),
          formatter: (row) => this.riskusersOpts.riskStatusOpts[row.risk_status]
        },
        {
          prop: 'confirm_status__formatted',
          label: '确认状态',
          width: 90,
          formatter: (row) => this.riskusersOpts.riskConfirmStatusOpts[row.confirm_status]
        },
        {
          prop: 'confirmed_adminusername__formatted',
          label: '负责人',
          formatter: row => row.confirmed_adminuserid ? (row.confirmed_adminusername + ' / ' + row.confirmed_adminuserid) : ''
        },
        { prop: 'confirmed_at', label: '确认时间' },
        { prop: 'became_risk_at', label: '触发风险时间' },
        { prop: 'last_active_tp', label: '最后登录时间', width: 160 },
      ],
      stats: {
        total_user_cnt: 0,
        customer_risk_user_cnt: 0,
        invalid_risk_user_cnt: 0,
        high_risk_percent: 0,
      }
    }
  },
  methods: {
    ...request.map([
      'getCustomerTable',
      'getCustomerDetail',
      'getBasicPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
    getTableData (params) {
      return request.page('queryRiskUsers', params)
    },
    loadStats (params) {
      params = removeEmptyParams(Object.assign({}, this.lastSearchParams, params))

      return request.page('getRiskUserStats', params).then(({ data }) => {
        filter.setLoop(this.stats, data)
      }).catch(() => {})
    },
    onTableSearch (params) {
      this.onSearch(params)
      this.loadStats(params)
    },
    isHighOrderPercent (row) {
      return row.customer_stats.length > 0 && this.isCustomerRisk(row.customer_stats[0])
    },
    isRiskClass (key, row) {
      if (key === 'customer_stats__formatted' && this.isHighOrderPercent(row)) {
        return true
      }
      if (key === 'total_invalid_percent__formatted' && this.isHighInvalidPercent(row)) {
        return true
      }
      if (key === 'risk_status__formatted' && this.isRiskStatus(row)) {
        return true
      }
    },
    onExportSearch () {
      this.$export(`${this.$route.meta.title}_搜索结果`, {
        fileHeader: this.fields.map((item) => ({
          key: item.prop,
          text: item.label,
          formatter: item.formatter,
        })),
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: removeEmptyParams(_.cloneDeep(this.search)),
      })
    },
    getChinaAreaData () {
      request.alert('queryAllFormatted').then(({ data }) => {
        this.chinaAreaData = Array.isArray(data) ? data : (Array.isArray(data && data.data) ? data.data : [])
      }).catch(() => {
        this.chinaAreaData = []
      })
    },
    joinCustomer (customers) {
      return customers
        .map(it => `${it.customername} ${it.order_percent}%`)
        .join('\n')
    },
    htmlRow (text) {
      if (text === null || text === undefined) {
        return ''
      }
      return String(text).replace(/\n/g, '<br>')
    }
  }
}
</script>

<style lang="scss" scoped>
.risk-user-stat-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px 20px;
  background: #fff;
}

.risk-user-stat-card__label {
  font-size: 14px;
  color: #909399;
  margin-bottom: 8px;
}

.risk-user-stat-card__value {
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  line-height: 1.2;
}

.is-risk {
  color: #f56c6c !important;
}
</style>



// WEBPACK FOOTER //
// src/views/users/pages/RiskUserTable.vue